module.exports = __webpack_public_path__ + "img/list_case_icon.9e0656cb.svg";